import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import type { IBannerTheme } from "app/components/React/TrialBanner/StyledTrialBanner";

import { useTimeLeft } from "../hooks/useTimeLeft";
import type { ITimeLeft } from "../utils/consts";

import { BoxContainer, Colon } from "./StyledComponent";

const TIME_UNITS: Array<keyof ITimeLeft> = ["days", "hours", "minutes", "seconds"];

interface ITimeCountingDiscountProps {
    discountEndTime?: string;
    bannerTheme: IBannerTheme;
}

export const TimeCountingDiscount = ({ discountEndTime, bannerTheme }: ITimeCountingDiscountProps) => {
    const timeLeft = useTimeLeft({ discountEndTime });

    return (
        <FlexRow id="TimeCountingDiscount">
            {TIME_UNITS.map((unit, index) => {
                const isLast = index === TIME_UNITS.length - 1;
                const timeLeftValue = String(timeLeft[unit]).padStart(2, "0");

                return (
                    <FlexRow key={`${unit}-${timeLeftValue}`}>
                        <BoxContainer $bannerTheme={bannerTheme}>{timeLeftValue}</BoxContainer>
                        {!isLast ? <Colon>:</Colon> : null}
                    </FlexRow>
                );
            })}
        </FlexRow>
    );
};
